import { VehicleAnalytics } from '../interfaces/interface.vehicle';
import { state as offerVehicleState } from '../store/store.offer-vehicle';
import { state as pageParamsState } from '../store/store.page-params';
import { state as questionsVehicleState } from '../store/store.question-vehicle';
import { state as vehicleConfigState } from '../store/store.vehicle-config';
import { BROWSER_STORAGE_TTL, getFromBrowserStorage, writeStoreToBrowserStorage } from '../utils/utils.store';

export const getVehicleData = (): VehicleAnalytics => {
  return {
    vehicle: {
      bodyStyle: offerVehicleState.bodyStyle.toString(),
      driveTrain: offerVehicleState.drivetrain.toString(),
      entry: pageParamsState.entry.toString(),
      makeId: offerVehicleState.makeId.toString(),
      makeName: offerVehicleState.make.toString(),
      modelId: offerVehicleState.modelId.toString(),
      modelName: offerVehicleState.model.toString(),
      trimName: offerVehicleState.trim.toString(),
      vehicleId: offerVehicleState.trimId.toString(),
      year: offerVehicleState.yearId.toString(),
    },
  };
};

export const getVehicleQuestionData = (): VehicleAnalytics => {
  return {
    vehicle: {
      bodyStyle: questionsVehicleState.bodyStyle.toString(),
      driveTrain: questionsVehicleState.drivetrain.toString(),
      entry: pageParamsState.entry.toString(),
      makeId: questionsVehicleState.makeId.toString(),
      makeName: questionsVehicleState.make.toString(),
      modelId: questionsVehicleState.modelId.toString(),
      modelName: questionsVehicleState.model.toString(),
      trimName: questionsVehicleState.trim.toString(),
      vehicleId: questionsVehicleState.trimId.toString(),
      year: questionsVehicleState.yearId.toString(),
    },
  };
};

export const getVehicleConfigData = (): VehicleAnalytics => {
  return {
    vehicle: {
      bodyStyle: vehicleConfigState.bodyStyle.toString(),
      entry: pageParamsState.entry.toString(),
      makeId: vehicleConfigState.makeId.toString(),
      makeName: vehicleConfigState.make.toString(),
      modelId: vehicleConfigState.modelId.toString(),
      modelName: vehicleConfigState.model.toString(),
      trimName: vehicleConfigState.trim.toString(),
      vehicleId: vehicleConfigState.trimId.toString(),
      year: vehicleConfigState.yearId.toString(),
    },
  };
};

export const formatReplacementTypes = (txt) => {
  return txt.replaceAll(', ', '::').replaceAll(' ', '').replace('Certified', 'cpo').toLowerCase();
};

export function getGTMContainerId(): string {
  return process.env.GTM_CONTAINER_ID ?? '';
}

export const isFirstEventFired = (store: string) => {
  try {
    const storedData = getFromBrowserStorage(store, false);
    if (!storedData) {
      writeStoreToBrowserStorage({ fired: true }, store, BROWSER_STORAGE_TTL.TTL1Hour);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error accessing browser storage:', error);
    return true;
  }
};
